import axios from "axios";
import axiosRetry from "axios-retry";
import { ResponseVehicle } from "services/motorpoint/shortlist";
import axiosOnSuccessEvent from "utils/axiosOnSuccessEvent";
import { logError } from "utils/logger";

const getVehicleRecommendations = async ({ stockNumber }: { stockNumber: string | number }) => {
    if (!stockNumber) return;
    try {
        axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

        const response = await axios.get<ResponseVehicle[]>(
            `${process.env.NEXT_PUBLIC_BASE_AWS_API_URL}/vehicle-recommendations/${stockNumber}`,
            {
                headers: {
                    Accept: "application/json",
                },
            }
        );

        axiosOnSuccessEvent(response);

        return response.data;
    } catch (e) {
        const error = e as { message: string; msg: string };
        logError(
            "Error from get vehicle recommendations request (getVehicleRecommendations)",
            error.msg
        );
        return undefined;
    }
};

export interface VehicleRecommendationByMakeAndModel {
    total: number;
    vehicles: ResponseVehicle[];
}

export const getVehicleRecommendationsByMakeAndModel = async ({
    make,
    model,
    variant,
}: {
    make: string;
    model?: string;
    variant?: string;
}): Promise<VehicleRecommendationByMakeAndModel | undefined> => {
    if (!make) return;

    try {
        axiosRetry(axios, { retries: 3, retryDelay: axiosRetry.exponentialDelay });

        const response = await axios.post<VehicleRecommendationByMakeAndModel>(
            `${process.env.NEXT_PUBLIC_BASE_AWS_API_URL}/vehicle-recommendations`,
            { make, model, variant },
            {
                headers: {
                    Accept: "application/json",
                },
            }
        );

        axiosOnSuccessEvent(response);

        return response.data;
    } catch (e) {
        const error = e as { message: string; msg: string };
        logError(
            "Error from get vehicle recommendations request (getVehicleRecommendationsByMakeAndModel)",
            error.msg
        );
        return undefined;
    }
};

export default getVehicleRecommendations;
